module.exports = __webpack_public_path__ + "static/media/templates-no-data.239809d0.jpg";